import { API_CALL } from 'actions/actionConstants'
import { FETCH_MERCHANDISE_BRANDS } from 'actions/apiActionConstants'
import { AppAction } from 'actions/types/ActionTypes'
import getMerchandiseBrands from 'api/merchandise/getMerchandiseBrands'

function fetchMerchandiseBrands(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const brandData = state.merchandise.merchandiseBrands

    if (brandData) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_MERCHANDISE_BRANDS,
      request: () => getMerchandiseBrands(),
    })
  }
}

export default fetchMerchandiseBrands
